import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'superscript', 'Superscript', [["path",{"d":"M5 7l8 10m-8 0l8 -10"}],["path",{"d":"M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"}]]);